import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromInspections from './inspections.reducer';

export const selectInspectionState = createFeatureSelector<fromInspections.InspectionState>(
  fromInspections.inspectionsFeatureKey
);

export const selectInspections = createSelector(selectInspectionState, inspectionState => inspectionState.listItems);

export const selectInspectionsLoading = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.listItemsLoading
);

export const selectResidentInspections = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.residentListItems
);

export const selectResidentInspectionsLoading = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.residentListItemsLoading
);

export const selectDynamicInspections = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.dynamicListItems
);
export const selectDynamicInspectionsLoading = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.dynamicListItemsLoading
);

export const selectDeletedDynamicInspectionId = createSelector(
  selectInspectionState,
  state => state.removedDynamicInspectionId
);

export const selectDeletedRepeatingInspectionId = createSelector(
  selectInspectionState,
  state => state.removedRepeatingInspectionId
);

export const selectRepeatingInspections = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.repeatingListItems
);
export const selectRepeatingInspectionsLoading = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.repeatingListItemsLoading
);

export const selectBulkInspections = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.bulkListItems
);
export const selectBulkInspectionsLoading = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.bulkListItemsLoading
);

export const selectBulkInspectionFilter = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.bulkInspectionFilter
);

export const selectInspectionFilter = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.inspectionFilter
);

export const selectInspectionsSummaryReport = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.summaryStats
);

export const selectInspectionsSummaryReportLoading = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.summaryReportDataLoading
);

export const selectInspectionsSummaryReportAppliedFilter = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.summaryStatsAppliedFilters
);

export const selectInReviewInspections = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.inReviewListItems
);

export const selectInReviewInspectionsLoading = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.inReviewListItemsLoading
);

export const selectInReviewInspectionFilter = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.inReviewInspectionFilter
);

export const selectRepeatingInspectionFilter = createSelector(
  selectInspectionState,
  inspectionState => inspectionState.repeatingInspectionFilter
);

export const selectInspectionSummaryStats = createSelector(
  selectInspectionState,
  state => state.inspectionSummaryStats
);
export const selectInspectionSummaryDetails = createSelector(
  selectInspectionState,
  state => state.inspectionSummaryDetails
);
export const selectInspectionSummaryLoading = createSelector(
  selectInspectionState,
  state => state.inspectionSummaryLoading
);
export const selectInspectionSummaryError = createSelector(
  selectInspectionState,
  state => state.inspectionSummaryError
);
